<template>
  <div class="mt-0">
    <div class="progress w-100">
      <div
          class="progress-bar progress-bar-striped progress-bar-animated"
          role="progressbar"
          :style="{ width: `${(progress/30) * 100}%` }"
          :aria-valuenow="progress"
          aria-valuemin="0"
          aria-valuemax="100"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenerationProgress',

  props: {
    progress: {
      type: Number,
      required: true
    }
  }
}
</script>